import {
    changeActiveWheels, changeCutType, changeIsRunflat,
    changeRadius,
    changeWheelDiskType, setCutType,
    setIsActive, setIsRunflat,
    setRadius,
    setWheelDiskType
} from "./constants";
import axios from '../../../plugins/axios-common';


export default {
    namespaced: true,
    state: {
        optionsListLoading: true,
        isFirstTab: true,
        availableTire:[
            12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24
        ],
        DiscRepairPrice: {},
        options: [],
        url: '/calc/',
        QRcodeUrl: '/QR.png',
        wheels: {
            forwardLeft: {
                isActive: false,
                data: {},
            },
            forwardRight: {
                isActive: false,
                data: {},

            },
            backLeft: {
                isActive: false,
                data: {},

            },
            backRight: {
                isActive: false,
                data: {},
            },
            spareLeft: {
                isActive: false,
                data: {},
            },
            spareRight: {
                isActive: false,
                data: {},
            },
        },
    },
    mutations: {
        addData (state, payload) {
            const {value, side} = payload;
            state.wheels[side].data = JSON.parse(JSON.stringify(value))
        },
        [setRadius](state, payload) {
            const {value, side} = payload;
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data.radius = value
                }
            } else{
                state.wheels[side].data.radius = value
            }
        },
        setRadiusRate(state, payload) {
            const {value, side} = payload;
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data.radiusRate = value
                }
            } else{
                state.wheels[side].data.radiusRate = value
            }
        },
        [setIsActive](state, payload) {
            const {value, side} = payload;
            state.wheels[side].isActive = value
        },
        [setWheelDiskType](state, payload) {
            const {value, side} = payload;
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data.solidDisk = value
                }
            } else{
                state.wheels[side].data.solidDisk = value
            }
        },
        [setIsRunflat](state, payload) {
            const {value, side} = payload;
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data.isRunflat = value
                }
            } else{
                state.wheels[side].data.isRunflat = value
            }
        },
        setOptions (state, value) {
            state.options = Object.assign({},state.options, value)
        },
        setDiscRepairPrice (state, value) {
            state.DiscRepairPrice = Object.assign({}, state.DiscRepairPrice, value)
        },
        addOptions (state, payload) {
            const {value, side} = payload
            state.wheels[side].data.options = Object.assign({},state.wheels[side].data.options, value)
        },
        diskDamageSet (state, payload) {
            const {value, item, side, id} = payload;
            state.wheels[side].data.diskDamage[id-1][item] = value
        },
        setPlus (state, payload) {
            const {value, item, side} = payload;
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data[item] = value
                }
            } else{
                state.wheels[side].data[item] = value
            }
        },
        setOptionsListLoading (state, value) {
            state.optionsListLoading = value
        },
        setIsFirstTab (state, value) {
            state.isFirstTab = value
        },
    },
    actions: {
        async init({ getters, commit, rootState }) {
            let data = {
                radius: parseInt(rootState.clientCard.diskSize.replace('R','')),
                radiusRate: 0,
                solidDisk: rootState.clientCard.diskType!=="shtamp",
                isRunflat: rootState.clientCard.runflat,
                diskType: 0,
                options: {},
                diskClass: 0,
                diskDamage:[
                    { id:1, inside: false, size: 1 , active: true },
                    { id:2, inside: false, size: 1 , active: false },
                    { id:3, inside: false, size: 1 , active: false },
                    { id:4, inside: false, size: 1 , active: false },
                    { id:5, inside: false, size: 1 , active: false },
                ],
                eightRepair: false,
                premium: false,
                edgeRepair: false,
                addRepair: false,
                addRepairNumbr: 1,
                // options
            }
            getters.sides.forEach(side => {
                commit('addData', {side: side.sideName, value:data})
            });
        },
        diskRepairPrice ({ commit }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: 'calc/disc-repair.json',
                })
                    .then((response) => {
                        console.log('disc-repair:', response.data)
                        commit('setDiscRepairPrice', response.data)
                        resolve(response.data)
                    }).catch((e) => {
                    reject(e)
                })
            })
        },
        setOptions ({ commit, getters }, value) {
            let tempWheelOptions = {}
            let tempOptions = {}
            value.forEach((x)=>{
                //

                tempOptions[x.id] = x
                tempWheelOptions[x.id] = false
                console.log('setOptions', x)

            })
            getters.sides.forEach(side => {
                commit('addOptions',  {side: side.sideName, value: tempWheelOptions})
            })
            commit('setOptions', tempOptions)
            commit('setOptionsListLoading', false)
        },
        setRadius({state, commit}, payload) {
            console.log('sss0',payload)
            const { value, side } = payload;
            commit(setRadius, payload)
            if(value > 12){
                for (let x in state.extraDiameters) {
                    //console.log(x)
                    if (state.extraDiameters[x].radius == value) {
                        commit('setRadiusRate', { side, value: state.extraDiameters[x].price})
                    }
                }
            }
        },
        [changeActiveWheels]({commit}, payload) {
            for (const side in payload) {
                commit(setIsActive, {side, value: payload[side]})
            }
        },
        [changeRadius]({state, commit}, payload) {
            const {side, value} = payload;
            const options = state.wheels[side].data.radius.map(option => {
                if (option.value === value) {
                    return {...option, selected: true}
                } else {
                    return {...option, selected: false}
                }
            });
            commit(setRadius, {side, value: options})
        },
        [changeWheelDiskType]({commit}, payload) {
            commit(setWheelDiskType, payload)
        },
        [changeIsRunflat]({commit}, payload) {
            commit(setIsRunflat, payload)
        },
        [changeCutType]({commit}, payload) {
            commit(setCutType, payload)
        },
    },

    getters: {
        sides: state => [
            {...state.wheels.forwardLeft, sideName: 'forwardLeft'},
            {...state.wheels.forwardRight, sideName: 'forwardRight'},
            {...state.wheels.backLeft, sideName: 'backLeft'},
            {...state.wheels.backRight, sideName: 'backRight'},
            {...state.wheels.spareLeft, sideName: 'spareLeft'},
            {...state.wheels.spareRight, sideName: 'spareRight'},
        ],
    },
}
